export const REPLY_BOX_MIN_HEIGHT_PX = 40;

export function getReplyBoxHeightPx(scrollHeight: number, minHeightPx = REPLY_BOX_MIN_HEIGHT_PX): number {
  if (!Number.isFinite(scrollHeight)) return minHeightPx;
  return Math.max(scrollHeight, minHeightPx);
}

type ReplyBoxHintPositionArgs = {
  markerTopPx: number;
  inputTopPx: number;
  markerHeightPx: number;
  hintHeightPx: number;
  lineHeightPx: number;
  paddingLeftPx: number;
  inputContentWidthPx: number;
  hintWidthPx: number;
  markerLeftPx: number;
  inputLeftPx: number;
  scrollTopPx?: number;
};

export function getReplyBoxHintPosition({
  markerTopPx,
  inputTopPx,
  markerHeightPx,
  hintHeightPx,
  lineHeightPx,
  paddingLeftPx,
  inputContentWidthPx,
  hintWidthPx,
  markerLeftPx,
  inputLeftPx,
  scrollTopPx: _scrollTopPx = 0,
}: ReplyBoxHintPositionArgs): { top: number; left: number; maxWidth: number } {
  const HINT_VERTICAL_NUDGE_PX = -1;
  let left = markerLeftPx - inputLeftPx - 1;
  let top = markerTopPx - inputTopPx + HINT_VERTICAL_NUDGE_PX;
  let maxWidth = Math.max(0, inputContentWidthPx - (left - paddingLeftPx));

  if (hintWidthPx > maxWidth && maxWidth > 0) {
    left = paddingLeftPx;
    top += lineHeightPx;
    maxWidth = inputContentWidthPx;
  }

  return {
    top: Math.max(0, Math.round(top)),
    left: Math.round(left),
    maxWidth: Math.round(maxWidth),
  };
}
